import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MythDivision from "./pages/MythDivision";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MythDivision />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
